import { Button } from "~/react/ui/button"
import { Icon } from "~/react/ui/icon"
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuAction,
} from "~/react/ui/dropdown-menu"
import { cn } from "~/lib/utils"

interface DataTableBulkActionsBarProps {
  totalCount: number;
  pageCount: number;
  selectedCount: number;
  onClearSelection: () => void;
  onSelectAll: () => void;
  onSelectPage: () => void;
}

export function DataTableBulkActionsBar({
  totalCount,
  pageCount,
  selectedCount,
  onClearSelection,
  onSelectAll,
  onSelectPage,
}: DataTableBulkActionsBarProps) {
  return (
    <header className={cn("h-table-bulk-actions", selectedCount > 0 && "is-visible")}>
      <Button
        size="sm"
        iconOnly
        type="button"
        onClick={onClearSelection}
        title={i18n.t("js.data_table.bulk_actions.clear_selection")}
        aria-label={i18n.t("js.data_table.bulk_actions.clear_selection")}
      >
        <Icon icon="times" aria-hidden="true" />
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="sm" type="button">
            <div>{i18n.t("js.data_table.bulk_actions.count_selected", { count: selectedCount })}</div>
            <Icon icon="angle-down" aria-hidden="true" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem>
            <DropdownMenuAction type="button" onClick={onSelectAll}>
              {i18n.t("js.data_table.bulk_actions.select_all")}
              <small className="grey ml-auto">({totalCount.toLocaleString("en-US")})</small>
            </DropdownMenuAction>
          </DropdownMenuItem>
          <DropdownMenuItem>
            <DropdownMenuAction type="button" onClick={onSelectPage}>
              {i18n.t("js.data_table.bulk_actions.select_page")}
              <small className="grey ml-auto">({pageCount.toLocaleString("en-US")})</small>
            </DropdownMenuAction>
          </DropdownMenuItem>
          <DropdownMenuItem className="h-table-bulk-actions__unselect">
            <DropdownMenuAction type="button" onClick={onClearSelection}>
              {i18n.t("js.data_table.bulk_actions.unselect_all")}
            </DropdownMenuAction>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
}
